import { AppState } from 'state/state.model';

const EMPTY_REJECTIONS = [] as const;
export function getRejections(state: AppState, formId: string) {
  return state.rejections[formId]?.errors ?? EMPTY_REJECTIONS;
}
